export default __webpack_public_path__ + "locales/uk-UA/Ldap.json?hash=0b90b17ef6dd7c9a13f67e86750ed310";